(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/start-page.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/start-page.js');
"use strict";

(function (svs, React, ReactRouterDOM) {
  'use strict';

  const {
    Route,
    withRouter
  } = ReactRouterDOM;
  const StartPage = () => React.createElement("div", {
    className: "grid-row padding-xs-1"
  }, React.createElement(ReactRouterDOM.Switch, null, React.createElement(Route, {
    component: svs.grassroots_partner.AddClub,
    exact: true,
    path: "/"
  }), React.createElement(Route, {
    component: svs.grassroots_partner.ClubAdded,
    exact: true,
    path: "/foreningansluten"
  }), React.createElement(Route, {
    component: svs.grassroots_partner.Login,
    exact: true,
    path: "/login"
  }), React.createElement(Route, {
    component: svs.grassroots_partner.Overview,
    exact: true,
    path: "/oversikt"
  }), React.createElement(Route, {
    component: svs.grassroots_partner.LoginClosed,
    exact: true,
    path: "/inloggningstangd"
  })), React.createElement("footer", {
    className: "align-center f-content padding-1 col-xs-12"
  }, React.createElement("div", {
    className: "padding-bottom"
  }, "Svenska Spels partnersupport"), React.createElement("div", {
    className: "padding-bottom"
  }, "Tfn: 0200 21 01 60"), React.createElement("div", {
    className: "padding-bottom"
  }, "Vardagar 07.00-24.00, helger 08.00-24.00"), React.createElement("div", null, React.createElement("a", {
    href: "mailto:partnersupport@svenskaspel.se?body=F%C3%B6reningsnamn%3A%0ARF-nummer%3A%0ABeskriv%20problemet%3A",
    rel: "noopener"
  }, "Skicka e-post"))));
  svs.grassroots_partner.StartPage = withRouter(StartPage);
})(svs, React, ReactRouterDOM);

 })(window);